<template>
  <BaseStepIndicator
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  >
    <template v-slot:node="props">
      {{ props.step.nodeLabel }}
    </template>
    <template v-slot:label="props">
      {{ props.step.label }}
    </template>
  </BaseStepIndicator>
</template>

<script>
  import BaseStepIndicator from '@base/v2/base-step-indicator'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'StepIndicatorPrimary',
    inheritAttrs: false,
    components: {
      BaseStepIndicator,
    },
    props: {
      nowrap: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        styleConfig: {
          container: {},
          label: {
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
            ...(this.nowrap ? {
              whiteSpace: 'nowrap',
            } : {}),
          },
          link: {
            height: '2px',
            width: '100%',
          },
          linkContainer: {
            alignItems: 'center',
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
          },
          node: {
            alignItems: 'center',
            borderRadius: '50%',
            display: 'flex',
            fontFamily: FontStyle.family.primary,
            fontSize: FontStyle.size.sm,
            fontWeight: FontStyle.weight.lg,
            height: '20px',
            justifyContent: 'center',
            width: '20px',
          },
          nodeContainer: {
          },
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.label,
        {
          color: {
            '': this.color.overlayBorder1(),
            disabled: this.color.dark3(),
          },
        }
      );
      Object.assign(
        this.styleConfig.link,
        {
          backgroundColor: {
            '': this.color.overlayBorder1(),
            disabled: this.color.dark3(),
          },
        },
      );
      Object.assign(
        this.styleConfig.node,
        {
          backgroundColor: {
            '': this.color.light1(),
            doing: this.color.overlayBorder1(),
            disabled: this.color.light1(),
          },
          border: {
            '': `solid ${this.color.overlayBorder1()}`,
            disabled: `solid ${this.color.dark3()}`,
          },
          borderWidth: '1px',
          color: {
            '': this.color.overlayBorder1(),
            doing: this.color.light1(),
            disabled: this.color.dark3(),
          },
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
